function trackLeadSubmission(result, reason) {
    var reasons = ['LOCAL_VALIDATION', 'CAPTCHA_REQUIRED', 'CAPTCHA_LOAD_ERROR', 'CAPTCHA_EXECUTE_ERROR', 'DATA_ERROR', 'SPAM_ERROR', 'MASSIVE_ATTACK_ERROR', 'AD_NOT_FOUND', 'AGENCY_CONFIGURATION_ERROR', 'OPERATION_NOT_SUPPORTED', 'NETWORK_ERROR', 'UNKNOWN_ERROR'];
    if (['viewed', 'attempted', 'failed', 'success'].indexOf(result) < 0) return;
    try {
        var instance = window.__mushroomInstance;
        if (!instance) return;
        instance.Trackers.create('adv.logger', {}).emit('METRIC', {
            name: 'lead_submit',
            tags: [
                {key: 'source', value: 'web'},
                {key: 'implementation', value: 'web_legacy'},
                {key: 'result', value: result},
                {key: 'reason', value: result !== 'failed' ? 'none' : reasons.indexOf(reason) >= 0 ? reason : 'UNKNOWN_ERROR'}
            ]
        });
    } catch (error) {}
}

trackLeadSubmission.observeForm = function (form) {
    if (!form || typeof IntersectionObserver === 'undefined') return;
    try {
        var observer = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            trackLeadSubmission('viewed');
        });
        observer.observe(form);
    } catch (error) {}
};

module.exports = trackLeadSubmission;
